export const SECTION_ROOT = "/journal";
